import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import Home from './home';
import Collaboration from './Collaboration';
import About from './about';
import Faqs  from './faqs';
import Termcondition  from './termcondition';
import Privacypolicy  from './privacypolicy';
import TestimonialSlider  from './Testimonial';
import Careerpage  from './Careerpage';
import Blogs  from './Blog';
import ScrollToTop from './ScrollToTop'; // ✅ Add this line


function App() {
  return (
    <Router>
      <ScrollToTop /> {/* ✅ Add this component inside Router */}
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="collaboration" element={<Collaboration />} />
          <Route path="about" element={<About />} />
          <Route path="faqs" element={<Faqs />} /> 
          <Route path="termcondition" element={<Termcondition />} /> 
          <Route path="privacypolicy" element={<Privacypolicy />} /> 
          <Route path="Testimonial" element={<TestimonialSlider />} /> 
          <Route path="Blog" element={<Blogs />} /> 
         <Route path="careerpage" caseSensitive={false} element={<Careerpage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
